export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_alphaquant.png",
      alt: "Estratégias AlphaQuant",
    },
    title: "Muito Além de um Robô de Trading ",
    text: [
      "O AlphaQuant não é um simples robô de trading. Ele é um sistema de inteligência quantitativa, desenvolvido com as mesmas metodologias avançadas usadas por grandes fundos de investimento e instituições financeiras. \n\nCombinando tecnologia de ponta, rigor analítico e um foco inabalável em resultados consistentes, o AlphaQuant oferece a traders e investidores de todos os níveis o que há de mais sofisticado e eficiente no universo do trading quantitativo. \n\nUma solução profissional, acessível e poderosa, criada",
    ],
    testimonial: {
      text: "Transformando dados em resultados",
      author: {
        name: "Clayton Barros e Ivan Semchechem – Quant Traders",
        picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  features: {
    title: "Por que utilizar os robôs da AlphaQuant",
    subtitle: "Veja quais as principais vantagens dos robôs da AlphaQuant.",
    data: [
      {
        title: "Tecnologia de Nível Institucional",
        description:
          "Acesso a estratégias quantitativas desenvolvidas com as mesmas metodologias utilizadas por grandes fundos de investimento, porém de forma acessível e democratizada para investidores individuais. ",
      },
      {
        title: "Estratégias Complementares",
        description:
          "Sistema único que opera com oito estratégias diferentes e complementares, proporcionando maior segurança e melhor distribuição de risco em diferentes cenários de mercado. ",
      },
      {
        title: "Validação Científica Rigorosa",
        description:
          "Mais de 800.000 testes realizados através do método Walk Forward Analysis, garantindo que cada estratégia seja exaustivamente validada com dados reais dos últimos 5 anos de mercado.",
      },
      {
        title: "Adaptação Contínua ao Mercado",
        description:
          " Revisão semestral das estratégias com novas baterias de testes e atualizações de parâmetros, assegurando que o sistema permaneça alinhado às condições atuais do mercado.",
      },
      {
        title: "Automação Inteligente",
        description:
          "Elimina decisões emocionais e executa operações de forma precisa e disciplinada, seguindo estritamente as estratégias programadas e testadas.",
      },
      {
        title: "Suporte de Especialistas",
        description:
          "Respaldo de profissionais com décadas de experiência no mercado financeiro, combinando expertise prática com conhecimento técnico avançado. ",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo as estratégias AlphaQuant e transforme seus resultados. ",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A AlphaQuant",
    col1: [
      "Nascido da convergência entre inovação tecnológica e expertise financeira, a AlphaQuant representa uma revolução no mercado de trading quantitativo. Nossa missão é democratizar o acesso a estratégias sofisticadas de investimento, antes restritas apenas a grandes instituições financeiras.",
      "Desenvolvemos soluções que transcendem os padrões convencionais do mercado, combinando ciência de dados e análise estatística avançada para criar algoritmos proprietários que se adaptam constantemente às dinâmicas do mercado financeiro. Nossa tecnologia permite que investidores de todos os níveis tenham acesso a estratégias robustas e cientificamente validadas. ",
    ],
    col2: [
      "Nossa equipe é liderada por Clayton Barros, profissional com mais de 28 anos de experiência no mercado financeiro, incluindo passagens por instituições globais como Citibank e HSBC e Ivan Semchechem, engenheiro e trader quantitativo. Nos últimos 7 anos, temos nos dedicado intensivamente ao desenvolvimento de soluções quantitativas e à formação de traders profissionais, trazendo para a AlphaQuant metodologias avançadas inspiradas nas práticas dos maiores fundos de investimento do mundo. ",
      "Com um compromisso inabalável com a excelência e inovação, nossa equipe trabalha continuamente para oferecer soluções que combinam sofisticação técnica com acessibilidade, permitindo que nossos usuários atinjam resultados consistentes e superiores no mercado financeiro. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da AlphaQuant",
  },
  strategies: {
    title: "Sistema alphaQuant ",
    heading: "Portfólio Quantitativo Avançado",
    subtitle: "Desenvolvido com ciência de dados e modelos estatísticos.",
  },
  testimonials: [
    {
      text: "Ao longo dos anos, venho buscando uma solução consistente para operar no day trade, e posso afirmar que não foi fácil. Desde 2011, passei pelo Forex e acumulei grandes prejuízos, além de ter investido tempo e dinheiro em diversos “gurus” e “falsos gurus” nos últimos quatro anos, sem resultados satisfatórios.  \n\nSou extremamente analítico e crítico, e raramente dou depoimentos. No entanto, hoje eu posso dizer, com segurança, que estou muito satisfeito com os resultados dos robôs do sistema alphaQuant . O alp",
      author: "Mário Henrique",
      job: "Funcionário Público Federal ",
      image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Já tive inúmeros robôs adquiridos no mercado e  todos só perdem dinheiro adoidado. \n\nTudo máquina de moer dinheiro.  \n\nO AlphaQuant é o primeiro robô que deixei rodar mais de 30 dias e agora, com mais de 10 meses rodando, falo com a experiência de quem já comprou todos robôs que viu pela frente: esse é o único que para em pé e fecha  positivo. O Clayton e o Ivan são éticos e os robôs realmente funcionam. ",
      author: "Daniel Soares ",
      job: "Corretor de Imóveis",
      image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
